// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__356Ni","list":"BalanceDue_list__3T0md","listRow":"BalanceDue_listRow__3YMDV","total":"BalanceDue_total__1SS80"};